import CapsuleTab from '@repo/ui/capsule-tab'
import React from 'react'

import { getOl } from '../../../api/ols/get-ol'
import { getOlHeader } from '../../../lib/constants/ol-permissions'
import useAuth from '../../../lib/hooks/use-auth'
import { useDataProps } from '../../../lib/hooks/use-data-props'
import { useNavigateSections } from '../../../lib/hooks/use-navigate-sections'
import { Ol } from '../../../lib/types/models/ol/ol'
import { DataProps } from '../../../lib/types/utils'

type Props = {
  mode: 'create' | 'update'
}

const OlHeader: React.FC<DataProps<Ol, Props>> = (props) => {
  const { data: ol, mode } = useDataProps(props, (id) => getOl(id))
  const { user } = useAuth()

  const sections = getOlHeader({ role: user.role, type: ol?.type, mode })

  const { activeTab, handleTabChange } = useNavigateSections({
    sections,
    allowNavigation: mode === 'update'
  })

  if (sections.length <= 0) return null

  return (
    <CapsuleTab
      variant="secondary"
      activeTab={activeTab}
      onTabChange={handleTabChange}
      tabs={sections.map(({ label, disabled }) => ({ label, disabled }))}
    />
  )
}

export default OlHeader
